import React from "react";

import urls from '../../../../../Utils/URLs';
import DashboardLayout from "../../../Layout/DashboardLayout";


function CreateCampaignLayout(props) {

    const menuItems = [
        //{
        //    icon: 'pe-7s-graph',
        //   label: 'Market Analysis',
        //    to: urls.CREATE_CAMPAIGN_MARKET_ANALYSIS_URL,
        //},
        {
            icon: 'pe-7s-graph',
            label: 'New Campaign',
            to: urls.CREATE_CAMPAIGN_INFO_URL,
        },
    ];

    return (
        <DashboardLayout
            menuItems={menuItems}
            heading="Create Campaign"
            icon="lnr-map text-info"
            subheading="Easily create automated Amazon advertising campaigns!"
        >
            {props.children}
        </DashboardLayout>
    );
}

export default CreateCampaignLayout;
